import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import api from "../api";
import { usePageTitle } from "../components/common";

export default function Confirmation() {
  usePageTitle("Confirmation");
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (sessionId) api.get(`/order/by-session/${sessionId}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [sessionId]);

  const isSos = order?.service_slug === "sos-sorciere";
  const bookingRequired = order?.booking_required;

  let title = "Tout est prêt ✨";
  let body =
    "Tu n'auras rien à faire pendant ton créneau.\n\nJe m'occupe du reste.";
  if (isSos) {
    title = "Ta demande SOS Sorcière est bien enregistrée ✨";
    body =
      "Dès que tes informations sont complètes, ta réponse sera préparée et envoyée sous 24 heures maximum.";
  } else if (!bookingRequired) {
    title = "Tout est bien reçu ✨";
    body = "Je me consacrerai pleinement à ta séance. Tu recevras ton compte rendu selon ta préférence.";
  }

  return (
    <div className="container-x py-20 sm:py-28 fade-up">
      <div className="max-w-xl mx-auto text-center card-soft p-10">
        <div className="w-16 h-16 rounded-full bg-[#C9A56A]/15 flex items-center justify-center mx-auto">
          <Sparkles className="text-[#C9A56A]" size={30} />
        </div>
        <h1 className="mt-6 font-serif text-3xl sm:text-4xl font-medium text-[#5A3A4B]">{title}</h1>
        <p className="mt-4 text-[#7A5D58] leading-relaxed whitespace-pre-line">{body}</p>
        <button onClick={() => navigate("/espace")} className="btn-primary mt-8" data-testid="confirmation-space-btn">
          Accéder à mon espace
        </button>
      </div>
    </div>
  );
}
